/**
 * Vanilla JS product archive – filtering & sorting
 * Works with pure-PHP rendered grid in content.php
 */

export default function initProductArchiveVanilla() {
  const root = document.getElementById("product-archive");
  if (!root) return;

  const grid = root.querySelector("#products-grid");
  const emptyState = root.querySelector("#product-empty-state");
  const activeFiltersEl = root.querySelector("#product-active-filters");
  const sortLabel = root.querySelector("#product-sort-label");

  // All product card columns
  const allCards = () => Array.from(grid.querySelectorAll(".product-card-col"));

  // ── state ────────────────────────────────────────────────────────
  let selectedTaste = new Set();
  let selectedGramatura = new Set();
  let currentSort = "menu-order";

  // ── helpers ──────────────────────────────────────────────────────
  function applyFilters() {
    const cards = allCards();
    let visibleCount = 0;

    cards.forEach((col) => {
      const cardTaste = col.dataset.taste ? col.dataset.taste.split(",") : [];
      const cardGram = col.dataset.gramatura
        ? col.dataset.gramatura.split(",")
        : [];

      const matchTaste =
        selectedTaste.size === 0 ||
        cardTaste.some((t) => selectedTaste.has(t));
      const matchGram =
        selectedGramatura.size === 0 ||
        cardGram.some((g) => selectedGramatura.has(g));

      if (matchTaste && matchGram) {
        col.style.display = "";
        visibleCount++;
      } else {
        col.style.display = "none";
      }
    });

    emptyState.style.display = visibleCount === 0 ? "" : "none";
    grid.style.display = visibleCount === 0 ? "none" : "";

    renderActivePills();
    syncMobileCheckboxes();
  }

  function applySort() {
    const cards = allCards();
    const sorted = cards.sort((a, b) => {
      switch (currentSort) {
        case "name-asc":
          return (a.dataset.variantName || "").localeCompare(
            b.dataset.variantName || "",
            "pl"
          );
        case "name-desc":
          return (b.dataset.variantName || "").localeCompare(
            a.dataset.variantName || "",
            "pl"
          );
        case "title-asc":
          return (a.dataset.title || "").localeCompare(
            b.dataset.title || "",
            "pl"
          );
        case "title-desc":
          return (b.dataset.title || "").localeCompare(
            a.dataset.title || "",
            "pl"
          );
        default: // menu-order
          return (
            parseInt(a.dataset.order, 10) - parseInt(b.dataset.order, 10)
          );
      }
    });
    sorted.forEach((c) => grid.appendChild(c));
  }

  // ── active filter pills ──────────────────────────────────────────
  function renderActivePills() {
    if (!activeFiltersEl) return;
    const pills = [];

    selectedTaste.forEach((name) => {
      pills.push(makePill(name, "taste"));
    });
    selectedGramatura.forEach((name) => {
      pills.push(makePill(name, "gramatura"));
    });

    activeFiltersEl.innerHTML = "";
    if (pills.length) {
      pills.forEach((p) => activeFiltersEl.appendChild(p));
      const clearBtn = document.createElement("button");
      clearBtn.className = "btn btn-outline-secondary btn-sm";
      clearBtn.textContent = "Wyczyść wszystkie";
      clearBtn.addEventListener("click", clearAll);
      activeFiltersEl.appendChild(clearBtn);
      activeFiltersEl.style.cssText = "";
    } else {
      activeFiltersEl.style.cssText = "display:none!important";
    }
  }

  function makePill(name, type) {
    const span = document.createElement("span");
    span.className =
      "badge-custom d-inline-flex align-items-center gap-1 badge bg-light text-dark";
    span.innerHTML = `${name} <button type="button" class="btn-close btn-close-sm ms-1" aria-label="Remove"></button>`;
    span.querySelector(".btn-close").addEventListener("click", () => {
      if (type === "taste") selectedTaste.delete(name);
      else selectedGramatura.delete(name);
      uncheckDesktop(name, type);
      applyFilters();
    });
    return span;
  }

  function uncheckDesktop(name, type) {
    const cls =
      type === "taste" ? "product-filter-taste" : "product-filter-gramatura";
    root.querySelectorAll(`.${cls}`).forEach((cb) => {
      if (cb.value === name) cb.checked = false;
    });
  }

  function clearAll() {
    selectedTaste.clear();
    selectedGramatura.clear();
    root
      .querySelectorAll(
        ".product-filter-taste, .product-filter-gramatura, .product-filter-taste-mobile, .product-filter-gramatura-mobile"
      )
      .forEach((cb) => (cb.checked = false));
    applyFilters();
  }

  // ── sync mobile ↔ desktop checkboxes ──────────────────────────
  function syncMobileCheckboxes() {
    root.querySelectorAll(".product-filter-taste-mobile").forEach((cb) => {
      cb.checked = selectedTaste.has(cb.value);
    });
    root.querySelectorAll(".product-filter-gramatura-mobile").forEach((cb) => {
      cb.checked = selectedGramatura.has(cb.value);
    });
    // Update mobile badge
    const totalActive = selectedTaste.size + selectedGramatura.size;
    const badge = root.querySelector(".product-filter-count");
    if (badge) {
      if (totalActive > 0) {
        badge.textContent = `(${totalActive})`;
        badge.style.display = "";
      } else {
        badge.style.display = "none";
      }
    }
  }

  // ── event listeners ──────────────────────────────────────────────
  // Desktop filter checkboxes
  root.querySelectorAll(".product-filter-taste").forEach((cb) => {
    cb.addEventListener("change", () => {
      cb.checked ? selectedTaste.add(cb.value) : selectedTaste.delete(cb.value);
      applyFilters();
    });
  });

  root.querySelectorAll(".product-filter-gramatura").forEach((cb) => {
    cb.addEventListener("change", () => {
      cb.checked
        ? selectedGramatura.add(cb.value)
        : selectedGramatura.delete(cb.value);
      applyFilters();
    });
  });

  // Mobile filter checkboxes
  root.querySelectorAll(".product-filter-taste-mobile").forEach((cb) => {
    cb.addEventListener("change", () => {
      cb.checked ? selectedTaste.add(cb.value) : selectedTaste.delete(cb.value);
      // Sync desktop
      root.querySelectorAll(".product-filter-taste").forEach((dcb) => {
        if (dcb.value === cb.value) dcb.checked = cb.checked;
      });
      applyFilters();
    });
  });

  root.querySelectorAll(".product-filter-gramatura-mobile").forEach((cb) => {
    cb.addEventListener("change", () => {
      cb.checked
        ? selectedGramatura.add(cb.value)
        : selectedGramatura.delete(cb.value);
      root.querySelectorAll(".product-filter-gramatura").forEach((dcb) => {
        if (dcb.value === cb.value) dcb.checked = cb.checked;
      });
      applyFilters();
    });
  });

  // Sort buttons
  root.querySelectorAll(".product-sort-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      currentSort = btn.dataset.sort;
      if (sortLabel) sortLabel.textContent = btn.textContent;
      applySort();
    });
  });

  // Clear-all buttons (empty state + pills)
  root.querySelectorAll(".product-clear-filters").forEach((btn) => {
    btn.addEventListener("click", clearAll);
  });

  // Mobile hamburger
  const hamburger = root.querySelector("#product-filter-hamburger");
  const mobileMenu = root.querySelector("#product-filter-mobile");
  const mobileClose = root.querySelector("#product-filter-mobile-close");

  if (hamburger && mobileMenu) {
    hamburger.addEventListener("click", () => {
      mobileMenu.classList.add("show");
      document.body.style.overflow = "hidden";
    });
  }
  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener("click", () => {
      mobileMenu.classList.remove("show");
      document.body.style.overflow = "";
    });
  }

  // Keep Bootstrap dropdowns open when clicking checkboxes
  root.querySelectorAll(".dropdown-menu").forEach((menu) => {
    menu.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  });
}
